"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyWebShareConfirmationCard = exports.SurveyWebShareCard = void 0;
const adaptivecards_1 = require("adaptivecards");
const __1 = require("../..");
function SurveyWebShareCard(survey, webUrl) {
    const card = __1.CardHelper.newCard();
    card.addItem(__1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: `Web link for: ${survey.title}`,
        wrap: true,
        size: adaptivecards_1.TextSize.Large,
    }));
    card.addItem(__1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: "Anyone from your company with this link can participate",
        wrap: true,
        size: adaptivecards_1.TextSize.Medium,
    }));
    card.addItem(__1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: `[${webUrl}](${webUrl})`,
        spacing: adaptivecards_1.Spacing.Medium,
        wrap: true,
    }));
    card.addAction(__1.CardHelper.create(adaptivecards_1.OpenUrlAction, {
        url: webUrl,
        title: "Open web link",
    }));
    return card;
}
exports.SurveyWebShareCard = SurveyWebShareCard;
function SurveyWebShareConfirmationCard(survey) {
    const card = __1.CardHelper.newCard();
    card.addItem(__1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: "Create a web sharing link for anyone in your company to participate on this polly?",
        size: adaptivecards_1.TextSize.Large,
        wrap: true,
    }));
    card.addAction(__1.CardHelper.create(adaptivecards_1.SubmitAction, {
        title: "🔗 Create link",
        isPrimary: true,
        data: (0, __1.SurveyWebShareCommand)(survey.id, true).toTaskFetchCommand(),
    }));
    return card;
}
exports.SurveyWebShareConfirmationCard = SurveyWebShareConfirmationCard;
//# sourceMappingURL=SurveyWebShareCard.js.map